module.exports = __webpack_public_path__ + "static/media/ewans-trust-logo-black.4d944854.svg";